var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationFilledPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45355 27.4652C9.5997 27.6098 9.79582 27.6914 9.99966 27.6914C10.2035 27.6914 10.3996 27.6098 10.5458 27.4652C10.5458 27.4652 13.9303 24.0692 16.6379 19.6678C18.484 16.6637 19.9993 13.1934 19.9993 9.99966C19.9993 4.48062 15.5187 0 9.99966 0C4.48062 0 0 4.48062 0 9.99966C0 13.1934 1.51533 16.6637 3.36142 19.6678C6.06902 24.0692 9.45355 27.4652 9.45355 27.4652ZM9.99966 5.38443C12.5457 5.38443 14.6149 7.45244 14.6149 9.99966C14.6149 12.5469 12.5457 14.6149 9.99966 14.6149C7.45359 14.6149 5.38443 12.5469 5.38443 9.99966C5.38443 7.45244 7.45359 5.38443 9.99966 5.38443Z",
    fill: "#203FD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilledPin);
export default __webpack_public_path__ + "static/media/locationFilledPin.a2d610aab39f6dafe8bc4c5e50fd3887.svg";
export { ForwardRef as ReactComponent };